import { mapActions, mapGetters } from 'vuex';
import NotificationSoundMixin from './NotificationSound';

export default {
  mixins: [NotificationSoundMixin],
  data() {
    return {
      userId: localStorage.getItem('userId'),
      titleNotification: '',
      pageTitle: document.title,
      documentVisible: document.visible,
      notificationInterval: 0,
    };
  },
  computed: {
    ...mapGetters({
      merchantActivity: 'pusher/merchantActivity',
      loadingMerchants: 'merchant/loadingMerchantList',
      merchantList: 'merchant/merchantList',
      unreadConversationsCount: 'chat/unreadConversationsCount',
    }),
  },
  watch: {
    titleNotification(notification) {
      if (notification) {
        this.addNotificationTitle();
      } else {
        this.removeNotificationTitle();
      }
    },
    merchantActivity(activity) {
      if ((activity.type === 'assignment') &&
        ((activity.meta_data.from_user_id === this.userId) || (activity.meta_data.to_user_id !== this.userId))
      ) {
        return;
      }

      const merchantIndex = this.$lodash.findIndex(this.merchantList, merchant => merchant.id === activity.merchant_id);
      this.merchantList[merchantIndex].unread_conversations = activity.merchant_unread_conversations;

      if (document.hidden) {
        this.titleNotification = (activity.type === 'assignment') ? '*New Conversation Assigned*' : '*New Message*';
      }

      if (this.$route.name !== 'Chat') {
        this.notifySound();
      }
    },
    merchantList(merchants) {
      if (merchants.length) {
        merchants.forEach((merchant) => {
          // this.listenForMerchantActivity(merchant.id);
        });
      }
    },
    unreadConversationsCount(unreadData) {
      if (unreadData && unreadData.merchant_id && this.merchantList.length) {
        const merchantIndex = this.$lodash.findIndex(this.merchantList, merchant => merchant.id === unreadData.merchant_id);
        this.merchantList[merchantIndex].unread_conversations = unreadData.unread_conversations;
      }
    },
  },
  mounted() {
    if (!this.loadingMerchants && !this.merchantList.length) {
      this.fetchMerchants();
    }
    window.onfocus = () => {
      this.titleNotification = '';
    };
  },
  methods: {
    ...mapActions({
      // listenForMerchantActivity: 'pusher/listenForMerchantActivity',
      fetchMerchants: 'merchant/fetchMerchants',
      setMerchantName: 'merchant/setMerchantName',
    }),
    userHasUnreadMessages(merchant) {
      if (this.$lodash.isEmpty(merchant.unread_conversations)) {
        return false;
      }

      return !!merchant.unread_conversations.all_unread || !!merchant.unread_conversations.user_unread[this.userId];
    },
    setBusinessName(name) {
      this.setMerchantName(name);
    },
    addNotificationTitle() {
      // this.changeFavIcon('/favicon-dot.ico');
      this.notificationInterval = setInterval(() => {
        document.title = (document.title === this.pageTitle) ? this.titleNotification : this.pageTitle;
      }, 2000);
    },
    removeNotificationTitle() {
      this.changeFavIcon('/favicon.ico');
      clearInterval(this.notificationInterval);
      document.title = this.pageTitle;
    },
    changeFavIcon(src) {
      // const link = document.createElement('link');
      const favicon = document.getElementById('favicon');
//      favicon.setAttribute('href', src);
      // link.id = 'favicon';
      // link.rel = 'icon';
      // link.type = 'image/svg+xml';
      // link.href = src;
      // if (oldLink) {
      //   document.head.removeChild(oldLink);
      // }
      // document.head.appendChild(link);
    },
  },
};
